import { StandardReport, Company } from '../../../models';
import { ReportSettingState } from '../report-setting';
import { runReport, RunReportResponse } from '../../../api';
import { createRunReportPayload } from './createRunReportPayload';
import { RuleBuilderField } from '../../create-report/rule-builder';

const runStandardReport = async (
  client: Company,
  report: StandardReport,
  reportSettingState: ReportSettingState,
  ruleBuilderFields: RuleBuilderField[],
  isCustomCalendar?: boolean,
  hybridReportName?: string,
  isCoaEnabled?: boolean,
): Promise<RunReportResponse> => {
  const payload = createRunReportPayload(
    client,
    report,
    reportSettingState,
    ruleBuilderFields,
    hybridReportName || report.preLocalizedName || report.name,
    isCustomCalendar,
    isCoaEnabled,
  );
  return runReport(payload);
};

export { runStandardReport };
